<template>
  <v-select
    ref="languageSwitch"
    v-model="selectedlanguage"
    class="language-switch"
    :items="languages"
    :prepend-icon="!onlyIcon ? '$language' : null"
    item-text="name"
    item-value="id"
    dense
    flat
    solo
    hide-details
    attach
    :menu-props="menuProps"
    @change="selectLanguage(selectedlanguage)"
  >
    <template v-if="onlyIcon" #prepend>
      <v-icon class="mx-4" color="primary" size="30" @click="openMenu"
        >$language</v-icon
      >
    </template>
  </v-select>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  name: "LanguaugeSwitch",
  props: {
    onlyIcon: {
      type: Boolean,
      required: false,
    },
  },
  data: () => ({
    selectedlanguage: 2,
  }),
  computed: {
    menuProps() {
      if (!this.onlyIcon) {
        return { offsetY: true };
      }
      return {
        offsetY: true,
        bottom: true,
        left: true,
        nudgeLeft: -50,
        nudgeBottom: 40,
        minWidth: 120,
      };
    },
    ...mapState("language", ["language", "languages", "titleKey"]),
  },

  mounted() {
    if (localStorage.language) {
      this.selectedlanguage = parseInt(localStorage.language);
    } else {
      this.selectedlanguage = this.language.id;
    }
  },
  methods: {
    selectLanguage(id) {
      this.changeLanguage(id);
      this.updatePageTitle(this.titleKey);
      this.$vuetify.lang.current = this.language.locale;
    },
    openMenu() {
      this.$refs.languageSwitch.$refs.input.click();
    },
    ...mapActions("language", ["changeLanguage", "updatePageTitle"]),
  },
};
</script>
